export const extractDateCreated = jsonLd => {
  if (jsonLd['schema:dateCreated']) {
    return jsonLd['schema:dateCreated'];
  }
};